<section *ngIf="forgotEmailToken" class="changepassword">
    <div class="changepassword__upper-content">
        <div class="changepassword__label">{{ 'INFO.CHANGE_PASSWORD' | translate }}</div>
        <div class="changepassword__links links">
            <p class="links__text">{{ 'INFO.NOTE_001' | translate }}</p>
            <a class="links__button" routerLink="/login">{{ 'INFO.SIGN_IN' | translate }}</a>
        </div>
    </div>
    <form class="forgotpassword__main-content" [formGroup]="changePasswordForm"
        (ngSubmit)="onChangePassowrdFormSubmit()" id="forgotpassword-form" novalidate>
        <div class="forgotpassword__wrapper">
            <div class="headline ">
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-row label-info">
                        <label for="password">{{ 'LOGIN.PASSWORD' | translate }}</label>
                        <div *ngIf="changePasswordFormControls.password?.invalid && (changePasswordFormControls.password?.dirty || changePasswordFormControls.password?.touched)"
                            class="alert alert-danger">
                            <div style="padding-top: 30px;" class="d-flex flex-row alert-danger-content">
                                <span>{{ 'INFO.INVALID_INPUT' | translate }}</span>
                                <div class="alert-danger-info"
                                    *ngIf="changePasswordFormControls.password?.errors?.['required']"
                                    matTooltipClass="tooltip-danger"
                                    matTooltip="{{ 'INFO.PASSWORD_REQUIRED' | translate }}">
                                    <div>?</div>
                                </div>
                                <div class="alert-danger-info"
                                    *ngIf="changePasswordFormControls.password?.errors?.['minlength'] || changePasswordFormControls.password?.errors?.['pattern']"
                                    matTooltipClass="tooltip-danger"
                                    matTooltip="{{ 'INFO.PASSWORD_PATTERN' | translate }}"
                                    style="cursor: pointer; position: relative; margin-left: 5px; width: 16px; height: 16px; background-color: #f05a1e; border-radius: 50%;">
                                    <div>?</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <input type="password" id="password" formControlName="password" name="password"
                        placeholder="{{ 'INFO.PLACEHOLDER' | translate }}" autocomplete>
                </div>
                <div class="col-12">
                    <div class="d-flex flex-row label-info">
                        <label style="width: 80%;" for="confirmPassword">{{ 'LOGIN.CONFIRM_PASSWORD' | translate
                            }}</label>
                        <div style="width: 20%;"
                            *ngIf="changePasswordFormControls.confirmPassword?.invalid && (changePasswordFormControls.confirmPassword?.dirty || changePasswordFormControls.confirmPassword?.touched)"
                            class="alert alert-danger">
                            <div style="padding-top: 30px;" class="d-flex flex-row alert-danger-content">
                                <div class="alert-danger-info"
                                    *ngIf="changePasswordFormControls.confirmPassword?.errors?.['required']"
                                    matTooltipClass="tooltip-danger"
                                    matTooltip="{{ 'INFO.PASSWORD_CONFIRM' | translate }}">
                                    <div>?</div>
                                </div>
                                <div class="alert-danger-info"
                                    *ngIf="changePasswordFormControls.confirmPassword.errors?.mustMatch"
                                    matTooltipClass="tooltip-danger"
                                    matTooltip="{{ 'INFO.PASSWORD_MATCH' | translate }}">
                                    <div>?</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <input type="password" id="confirmPassword" formControlName="confirmPassword" name="confirmPassword"
                        placeholder="{{ 'INFO.PLACEHOLDER' | translate }}">
                </div>
                <div class="col-12">
                    <button [disabled]="!changePasswordForm.valid" class="sendmail-button button full">{{
                        'INFO.CHANGE_PASSWORD' | translate }}</button>
                    <mat-spinner *ngIf="loadingPage" class="sign-in-spinner"></mat-spinner>
                </div>
            </div>
        </div>
    </form>
</section>
<p-progressSpinner *ngIf="spinner" class="full_spinner"></p-progressSpinner>
